export enum LoginTypePersonasEnum {
  INDIVIDUAL= 'individual',
  BUSINESS= 'business',
  GOVERNAMENTAL= 'governmental',
  LAWYERS= 'lawyers',
  ANONYMOUS ='anonymous'
};
